<template>
    <div id="timer" v-if="days >= 0">
      <div class="content">
        <div v-if="!loading && now !== null"> {{ hours | two_digits }} : {{minutes | two_digits}} : {{seconds | two_digits}}</div>
        <div v-else>00 : 00 : 00</div>
        <v-progress-circular
          v-if="loading"
          color="primary"
          :indeterminate="true"
          id="timtim"
        ></v-progress-circular>
      </div>

    </div>
</template>
<style>
  .content {
    width:100%;
    background-color: #ffffff;
    color: #EB5757;
    height: auto;
    /* font-size: 25px; */
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items:center;
  }
  @media only screen and (min-width: 760px) {
    .content {
      font-size: 25px;
     }
  }
  @media only screen and (max-width: 480px) {
    .content {
      font-size: 20px;
     }
  }
  .v-progress-linear {
    background: transparent;
    margin: 0 !important;
    overflow: hidden;
    width: 100%;
    position: relative;
  }
</style>
<script>
import moment from 'moment/src/moment'

export default {
  name: 'timer-component',
  props: {
    id: {
      type: String,
      required: false
    }
  },
  mounted () {
    this.start_time()
  },
  data () {
    return {
      now: null,
      date: null,
      typeofTO: null,
      ed: null,
      loading: false,
      intrvl: null
    }
  },
  filters: {
    two_digits: function (value) {
      if (value < 0) {
        return '00'
      }
      if (value.toString().length <= 1) {
        return `0${value}`
      }
      return value
    }
  },
  computed: {
    dateInMilliseconds () {
      return Math.trunc(Date.parse(this.date) / 1000)
    },
    seconds () {
      return (this.dateInMilliseconds - this.now) % 60
    },
    minutes () {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60
    },
    hours () {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24
    },
    days () {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24)
    }
  },
  methods: {
    start_time () {
      this.loading = true
      var getTryoutType = []
      var subTryout = null
      var context = this

      if (this.$route.name === 'mata-pelajaran' || this.$route.name === 'soal') {
        this.$store.dispatch('funcGetTryoutDetailV2Joined', parseInt(this.$route.params.id)).then(response => {
          getTryoutType = response.data
          subTryout = getTryoutType.tryouts.find(function (subelement) {
            return subelement.id === parseInt(context.$route.params.cid)
          })
          this.typeofTO = subTryout.type
          this.setting(subTryout)
        })
        // getTryoutType.forEach(element => {
        //   if (element.id === parseInt(this.$route.params.id)) {
        //     this.typeofTO = element.type
        //     // tryout_closedAt = element.closed_at
        //     subTryout = element.tryouts.find(function (subelement) {
        //       return subelement.id === parseInt(context.$route.params.cid)
        //     })
        //   }
        // })
      } else {
        getTryoutType = JSON.parse(sessionStorage.instantTestData)
        this.typeofTO = getTryoutType.type
        subTryout = getTryoutType.tryouts.find(function (subelement) {
          return subelement.id === parseInt(context.$route.params.cid)
        })
        this.setting(subTryout)
      }
    },
    setting (subTryout) {
      setTimeout(() => {
        if (subTryout !== null) {
          let enddatetime = subTryout.end_date + ' ' + subTryout.end_time
          var endTryout = moment(enddatetime, 'YYYY-MM-DD hh:mm:ss').format('X')
          if (this.now > endTryout) {
            // console.log('a')
            // this.$emit('timeup')
          }
        }
        var timeBase = null

        if (this.typeofTO === 'SBMPTN') timeBase = JSON.parse(localStorage.getItem(this.id + '-' + sessionStorage.UID))
        if (this.typeofTO !== 'SBMPTN') timeBase = JSON.parse(localStorage.getItem(this.$route.params.cid + '-' + sessionStorage.UID))
        var dates = null
        var sdate = timeBase
        this.ed = sdate.ed
        dates = sdate.sd + sdate.d * 60000
        var endDate = new Date(sdate.ed).getTime() / 1000
        this.loading = false
        this.$store.dispatch('getTime').then((res) => {
          var outnow = ''
          if (res.data) outnow = res.data.current_time + '' // servertime
          else outnow = res + ''
          var currTime = outnow.slice(0, -3)
          currTime = parseInt(currTime)
          this.intrvl = window.setInterval(() => {
            currTime += 1
            this.now = currTime
            if (endDate < this.now) {
              // console.log('a')
              this.$emit('timeup')
              clearInterval(this.intrvl)
            }
          }, 1000)
          if (dates / 1000 < currTime) {
            // console.log('a')
            this.$emit('timeup')
            clearInterval(this.intrvl)
          }
          this.date = moment(dates).format('MM/DD/YYYY HH:mm:ss')
        })
      }, 1000)
    }
  },
  created () {
    // clearInterval()
    // this.start_time()
    this.$store.watch(
      (state, getters) => getters.getStartConfirmation,
      (newValue, oldValue) => {
        if (newValue) {
          this.start_time()
        } else {
          this.start_time()
        }
      }
    )
    setTimeout(() => {
      if (this.hours === 0 && this.minutes === 0 && this.seconds === 0) {
        // console.log('a')
        this.$emit('timeup')
      }
    }, 1500)
  },
  watch: {
    seconds (to, from) {
      if (this.hours === 0 && this.minutes === 0 && this.seconds === 0) {
        // console.log('a')
        this.$emit('timeup')
      }
    }
  }
}
</script>
